'use strict';

import invariant from 'fbjs/lib/invariant';
export function get(name) {
  return null;
}
export function getEnforcing(name) {
  var module = get(name);
  invariant(module != null, "TurboModuleRegistry.getEnforcing(...): '" + name + "' could not be found. " + 'Verify that a module by this name is registered in the native binary.');
  return module;
}